import { Box } from '@material-ui/core';
import React, { FunctionComponent, useCallback } from 'react';
import goHomeButtonStyles from './GoHomeButtonStyles';
import Translation from '../../../../../common/components/presentation/Translation/Translation';
import ContinueButton from '../../../../common/components/continueButton/ContinueButton';

interface IGoHomeButton {
  homePageURL: string;
  myAccountDxpIntegration?: boolean;
}

const GoHomeButton: FunctionComponent<IGoHomeButton> = ({ homePageURL, myAccountDxpIntegration }) => {
  const style = goHomeButtonStyles();

  const redirectToHomePage = useCallback(() => {
    window.location.href = homePageURL;
  }, [homePageURL]);

  return (
    <Box className={myAccountDxpIntegration ? style.buttonWrapperWithMyAccount : style.buttonWrapper}>
      <ContinueButton
        className={style.button}
        testId={'button:confirmation:redirectHome'}
        withIcon={true}
        onClick={redirectToHomePage}
      >
        <Translation className={style.buttonText} id={'trans__checkout__confirmation_page__home_page_button'} />
      </ContinueButton>
    </Box>
  );
};

export default GoHomeButton;
